<template lang="pug">
    .noData.mt-8
      v-row
        v-col(cols="6" offset="3"  )
          v-row.py-8(align="center")
            v-col(cols="12" md="7")
              v-card.elevation-0
                v-card-title.justify-center.justify-md-start(v-text="title")
                v-card-subtitle.text-center.text-md-left(v-text="subtitle") 
                v-card-actions.justify-center.justify-md-start
                  UploadDropZone.ma-4(v-if="action.to == 'upload'")
                  v-btn.ml-2(v-else :to="action.to" color="accent" small outlined) {{action.title}}
            v-col(cols="12" md="5"  )
              svg-image(:image="image" )
</template>

<script>
import SvgImage from "@/components/shared/SvgImage";
import UploadDropZone from "@/components/uploads/UploadDropZone";
export default {
  name: "NoDataNotice",
  components: {
    SvgImage,
    UploadDropZone,
  },
  props: ["title", "subtitle", "image", "action"],
};
</script>
